import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="container">
        <div className="page-header">
          <h1>Privacy Policy</h1>
          <p className="page-subtitle">How we protect and use your information</p>
        </div>

        <section className="privacy-content">
          <div className="privacy-text">
            <div className="policy-section">
              <h2>1. INTRODUCTION</h2>
              <p>
                1.1. Record News ("we", "us", "our") is committed to protecting the personal information you provide to us.
              </p>
              <p>
                1.2. This privacy policy ("this Policy") explains how we collect, use, and protect your Personal Information.
              </p>
              <p>
                1.3. By providing us with your Personal Information, you:
              </p>
              <ul>
                <li>1.3.1. agree to this Policy and authorise us to process such information as set out herein; and</li>
                <li>1.3.2. authorise Record News, our Service Providers and other third parties to Process your Personal Information for the purposes stated in this Policy.</li>
              </ul>
              <p>
                1.4. We will not use your Personal Information for any other purpose than that set out in this Policy and will endeavour to protect your Personal Information that is in our possession from unauthorised alteration, loss, disclosure, or access.
              </p>
              <p>
                1.5. Please note that we may review and update this Policy from time to time. The latest version of this Policy will always be available on our website.
              </p>
            </div>

            <div className="policy-section">
              <h2>2. COLLECTION OF PERSONAL INFORMATION</h2>
              <p>2.1. We may collect or obtain Personal Information about you:</p>
              <ul>
                <li>2.1.1. directly from you;</li>
                <li>2.1.2. when you subscribe to our services (e.g., digital or print subscriptions);</li>
                <li>2.1.3. when you submit tips, comments, or content to us;</li>
                <li>2.1.4. when you attend our events or webinars;</li>
                <li>2.1.5. when you make your Personal Information public;</li>
                <li>2.1.6. when you visit and/or interact with our Website, mobile applications, or our various social media platforms;</li>
                <li>2.1.7. when you register to use any of our services including but not limited to newsletters, alerts, and competitions;</li>
                <li>2.1.8. when you interact with any third-party content or advertising on our Website; or</li>
                <li>2.1.9. in the course of our journalistic activities, from public sources or third parties.</li>
              </ul>
              <p>
                2.2. We may also receive Personal Information about you from third parties (e.g., verification services, social media platforms).
              </p>
            </div>

            <div className="policy-section">
              <h2>3. CATEGORIES OF PERSONAL INFORMATION WE MAY PROCESS</h2>
              <p>3.1. We may process the following categories of Personal Information about you:</p>
              <ul>
                <li><strong>Personal Details:</strong> name; and photograph;</li>
                <li><strong>Demographic Information:</strong> gender; date of birth / age; nationality; salutation; title; and language preferences;</li>
                <li><strong>Identifier Information:</strong> passport or national identity number (e.g., for competition verification);</li>
                <li><strong>Contact Details:</strong> correspondence address; telephone number; email address; and details of your public social media profile(s);</li>
                <li><strong>Subscription and Billing Details:</strong> account credentials; billing address; payment method; bank account number or credit card number; invoice records; payment records; and subscription history;</li>
                <li><strong>Reader Contributions:</strong> Personal Information included in letters to the editor, comments, user-generated content, tips, and submissions;</li>
                <li><strong>Consent Records:</strong> records of any consents you may have given;</li>
                <li><strong>Data Relating to Your Visits to Our Website/Apps:</strong> your device type; operating system; browser type; browser settings; IP address; language settings; dates and times of connecting to our services; and other technical communications information;</li>
                <li><strong>Content and Advertising Data:</strong> records of your interactions with our online advertising and content; and</li>
                <li><strong>Employment Details:</strong> where you interact with us in your capacity as a job applicant, your CV, work history, and other relevant employment information.</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>4. DATA SECURITY</h2>
              <p>
                4.1. We implement appropriate technical and organisational security measures to protect your Personal Information that is in our possession against accidental or unlawful destruction, loss, alteration, unauthorised disclosure, unauthorised access, in accordance with applicable law.
              </p>
              <p>
                4.2. Where there are reasonable grounds to believe that your Personal Information that is in our possession has been accessed or acquired by any unauthorised person, we will notify the relevant regulator and you, unless a public body responsible for detection, prevention or investigation of offences or the relevant regulator informs us that notifying you will impede a criminal investigation.
              </p>
            </div>

            <div className="policy-section">
              <h2>5. YOUR LEGAL RIGHTS</h2>
              <p>
                5.1. You may have rights under the South African and other laws to have access to your Personal Information and to ask us to rectify, erase and restrict use of, your Personal Information. You may also have rights to object to your Personal Information being used, to ask for the transfer of Personal Information you have made available to us and to withdraw consent to the use of your Personal Information.
              </p>
            </div>

            <div className="policy-section">
              <h2>6. DIRECT MARKETING</h2>
              <p>
                6.1. We may Process your Personal Information for the purposes of providing you with information regarding our services, subscriptions, and promotions that may be of interest to you. You may unsubscribe for free at any time by using the link in any marketing email or by contacting us.
              </p>
              <p>
                6.2. If you currently receive marketing information from us which you would prefer not to receive in the future, please email us at: <a href="mailto:privacy@recordnews.co.za">privacy@recordnews.co.za</a>
              </p>
            </div>

            <div className="policy-section">
              <h2>7. CONTACT US</h2>
              <p>
                If you have any questions about this Privacy Policy or how we handle your personal information, please contact our Privacy Officer at <a href="mailto:privacy@recordnews.co.za">privacy@recordnews.co.za</a>
              </p>
              <p>
                <strong>Last updated:</strong> December 2024
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;